import Vue from 'vue'
import detectHoverTouch from './client/detect-hover-touch'
import viewportSizes from './client/viewport-sizes'
import readingTime from './client/reading-time.js'

Vue.use(detectHoverTouch)
Vue.use(viewportSizes)
Vue.use(readingTime)
